import { LatLonDMS } from "./coord-dms";

export class HorizonRecord {
  centerLatitude : number;
	centerLongitude : number;
  targetLatitude: number;
  targetLongitude: number;
	minDepth : number;
	maxDepth : number;
	minStep : number;
	heigthAboveTerrain : number;
  terrainElevation: number;
  centerLatLonDms:LatLonDMS = new LatLonDMS();
  targetLatLonDms:LatLonDMS = new LatLonDMS();
}
